import { Edit, TrashAlt, Car } from '@styled-icons/boxicons-solid'
import { downloadFileBlob, formatEmptyValue } from '../../../utils/common'
import LinkWithStatus from '../../common/LinkWithStatus'
import { deleteRequest, getRequest } from '../../../services/base'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import PlantEditCreateForm from './form'
import Tooltip from '../../common/tooltip'
import NoRecordsFound from '../../common/NoRecordsFound'
import PlantVehicles from './form/PlantVehicles'

const PlantListRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-2/12 pl-10 items-center table_text">
          <Tooltip message={props.name}>
            <div>{props.name}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          {formatEmptyValue(props.vin_identifier)}
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          {formatEmptyValue(props.time_zone)}
        </div>
        <div className="w-2/12 pl-6 table_text">
          {formatEmptyValue(props.location)}
        </div>
        <div className="w-2/12 pl-6">{formatEmptyValue(props.make)}</div>

        <div className="flex w-2/12 justify-end ">
          <div>
            <span
              onClick={() => {
                props.addEditVehicles()
              }}
              className="cursor-pointer p-2"
            >
              <Car size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <TrashAlt size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const PlantList = (props) => {
  const [state, dispatch] = useContext(NavContext)
  const [plantsListData, setPlantsListData] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const [selectedPlant, setSelectedPlant] = useState({})
  const [showPlantVehicleModal, setShowPlantVehicleModal] = useState(false)

  useEffect(() => {
    getPlantList(null)
  }, [])

  const getPlantList = async (url = null) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Plant`s Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(
      url ? url : `/api/plants/?search=${searchValue}`
    )
    setPlantsListData(response.results)
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deletePlant = async (plant_obj) => {
    if (
      window.confirm(`Are you sure you want to Delete ${plant_obj.name} Plant`)
    ) {
      let res = await deleteRequest(`/api/plants/delete/${plant_obj.id}/`)
      getPlantList(null)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Plant Deleted Successfully`,
        },
      })
    }
  }

  const downloadPlantMakeModels = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: `Downloading Plant Make Models csv file is in progress.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/plants/download_plant_make_models/`,
      true,
      true
    )
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `plant_make_model.csv`)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  return (
    <>
      {showModal && (
        <PlantEditCreateForm
          showModal={showModal}
          setShowModal={setShowModal}
          getPlantList={getPlantList}
          selectedPlant={selectedPlant}
          onSave={() => {
            getPlantList()
            setShowModal(false)
          }}
        />
      )}

      {showPlantVehicleModal && (
        <PlantVehicles
          showModal={showPlantVehicleModal}
          setShowModal={setShowPlantVehicleModal}
          selectedPlant={selectedPlant}
        />
      )}

      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          getPlantList(null)
        }}
      >
        <div className="flex space-x-5">
          <div className="w-1/3">
            <input
              autoComplete="off"
              className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none text-black"
              placeholder="Enter to search"
              type="search"
              name="search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value)
              }}
            />
          </div>
          <button className="bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded">
            Search
          </button>

          <div className="w-2/3 font-light text-right space-x-5 flex justify-end">
            <LinkWithStatus
              href={`/administration/plant/export_plant_make_models`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Export Plant Make Models"
              onClickFunc={() => {
                downloadPlantMakeModels()
              }}
            />
            <LinkWithStatus
              href={`/administration/plant/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Plant"
              onClickFunc={() => {
                setSelectedPlant({})
                setShowModal(true)
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-10 items-center">Name</div>
          <div className="flex w-2/12 pl-6 items-center">Vin Identifier</div>
          <div className="flex w-2/12 pl-6 items-center">Time Zone</div>
          <div className="w-2/12 pl-6">Location</div>
          <div className="w-2/12 pl-6">Make Details</div>

          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {plantsListData?.map((plant_obj, index) => {
        return (
          <PlantListRow
            {...plant_obj}
            key={`plant-${index}`}
            onEdit={() => {
              setSelectedPlant(plant_obj)
              setShowModal(true)
            }}
            onDelete={() => {
              deletePlant(plant_obj)
            }}
            addEditVehicles={() => {
              setSelectedPlant(plant_obj)
              setShowPlantVehicleModal(true)
            }}
          />
        )
      })}

      {plantsListData?.length < 1 && (
        <NoRecordsFound caption={"Plant's Not Found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getPlantList(e)
          }}
          onClickPrev={(e) => {
            getPlantList(e)
          }}
        />
      </div>
    </>
  )
}

export default PlantList
